import React, { useMemo } from "react";
import { StyleProp, StyleSheet, useWindowDimensions, ViewStyle } from "react-native";
import Animated, { SharedValue, interpolate, useAnimatedStyle } from "react-native-reanimated";

export type CarouselElementType = {
    stepIndex: number;
    scrollScale?: number;
    style?: StyleProp<ViewStyle>;
    component: React.ReactElement;
};

type CarouselElementProps = {
    scrollValue: SharedValue<number>;
    totalLength: number;
    element: CarouselElementType;
};

const CarouselElement = ({ scrollValue, totalLength, element }: CarouselElementProps) => {
    const { stepIndex, scrollScale = 1, component, style } = element;
    const styles = useStyles();

    const { width } = useWindowDimensions();

    const animStyle = useAnimatedStyle(() => {
        const length = totalLength - 1;

        const outputFinal = width * length;

        const scale = 1 - scrollScale;

        const scaleDiff = outputFinal * scale;

        const inputRange = [0, length];
        const outputRange = [0, outputFinal - scaleDiff];

        const final =
            width * (1 - scale) * stepIndex -
            interpolate(scrollValue.value, inputRange, outputRange);

        return {
            transform: [
                {
                    translateX: final,
                },
            ],
        };
    }, []);

    return <Animated.View style={[styles.container, style, animStyle]}>{component}</Animated.View>;
};

const useStyles = () => {
    return useMemo(
        () =>
            StyleSheet.create({
                container: {
                    position: "absolute",
                    zIndex: -1,
                },
            }),
        [],
    );
};

export default CarouselElement;
